import { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from '../../../../core/util/core/Fetch';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import Organogram from './organogram/components/Organogram';
import { useOrganogramContext } from './organogram/hooks/useOrganogramContext';

function Form() {
    const { loadNodesAndEdges, handleSubmit, nodes, edges, setPdcEntityId , clearMembers } =
        useOrganogramContext();
    const [form, setForm] = useState({});
    const { id } = useParams();

    const profileFilter = chooseProfileFilter();

    const hiddenValues = {};

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id;
        setPdcEntityId(profileFilter.pdc_entity_id);
    }

    const path = '/organizationalcharts/';
    const paths = {
        endpointSave: config.endpoints.backend + 'organizationalcharts/save',
        endpointGetById:
            config.endpoints.backend + 'organizationalcharts/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    };

    const labels = {
        labelTitleAdd: 'Novo Organograma',
        labelTitleEdit: 'Editar Organograma',
        labelTitleView: 'Visualizar Organograma'
    };

    const getForm = useCallback(
        (values) => {
            values.publish_date =
                values.publish_date && values.publish_date != ''
                    ? values.publish_date
                    : new Date();

            let form = {
                validateOnChange: true,
                hiddenValues: {
                    ...hiddenValues
                },
                handleSubmit: async (_, preparedValues) => {
                    await handleSubmit(preparedValues);
                },
                fields: [
                    !hiddenValues.pdc_entity_id
                        ? {
                              name: 'pdc_entity_id',
                              type: 'select',
                              label: 'Entidade',
                              options: [],
                              handleChange: async (element, field, values) => {
                                  setPdcEntityId(element.target.value);
                                  clearMembers();
                              },
                              optionsEndpoint: {
                                  endpoint: paths.endpointGetAllEntities,
                                  label: 'corporate_name',
                                  value: 'id',
                                  params: {
                                      filter: {
                                          ...profileFilter
                                      }
                                  }
                              },
                              validations: {
                                  required: true
                              },
                              columnSize: 12
                          }
                        : {},
                    {
                        name: 'publish_date',
                        type: 'date',
                        label: 'Data de Publicação',
                        validations: {
                            required: true
                        },
                        columnSize: 12
                    }
                ],
                ...paths,
                ...labels
            };
            form.values = values;
            return form;
        },
        [handleSubmit, hiddenValues, profileFilter]
    );

    const load = async (form) => {
        let values = form?.values || {};

        if (!form?.values) {
            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id });

                if (values?.pdc_entity_id) {
                    setPdcEntityId(values.pdc_entity_id);
                }
            }

            if (values.graph) {
                loadNodesAndEdges(values?.graph?.nodes, values?.graph?.edges);
            }
        }

        const newForm = getForm(values);

        setForm(newForm);
    };

    useEffect(() => {
        load(form);
    }, [nodes, edges]);

    if (!form?.values) {
        return <>carregando...</>;
    }

    return (
        <CustomFormContainer
            form={form}
            content={
                <CustomForm form={form}>
                    <Organogram />
                </CustomForm>
            }
        />
    );
}
export default Form;
